var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"value":_vm.item.options,"items":_vm.allOptions,"label":"Options","multiple":"","chips":"","deletable-chips":""},on:{"change":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }